import React from 'react'

export const tooltipOverlay = (tooltipEl, props) => {
  if (!React.isValidElement(tooltipEl)) return tooltipEl

  const mergedProps = {
    ...tooltipEl.props, // original Tooltip props
    ...props, // overlay props injected here (e.g., style, ref, placement)
    className: [tooltipEl.props.className, props.className].filter(Boolean).join(' ')
  }

  return React.cloneElement(tooltipEl, mergedProps)
}
